'use client'

import { useEffect } from 'react'
import Bugsnag from '@bugsnag/js'

export default function GlobalError({
  error,
}: {
  error: Error & { digest?: string }
}) {
  useEffect(() => {
    if (Bugsnag.isStarted()) Bugsnag.notify(error)
  }, [error])

  return (
    <html lang="pt-BR">
      <body>
        <h2>Algo deu errado.</h2>
      </body>
    </html>
  )
}
